import CustomUserRoutes from './customUser/customUserRoutes';
// ==============================|| MAIN ROUTING ||============================== //

const CustomSettingsRoutes = {
    path: 'customerSetting',
    children: [CustomUserRoutes]
};

export default CustomSettingsRoutes;
